import templateUrl from './payroll-analysis-summary-detail-table.component.html'

export const PayrollAnalysisSummaryDetailTableComponent = {
    templateUrl,
    bindings: {
        payrollAnalysisSummary: "<",
        noShowFilters: "<"
    },
    controllerAs: "vm"
};
